/** Converts a string to a URL-safe slug.
 * @param {string} [str=''] - The string to sanitize.
 * @returns {string} URL-safe slug.
 *
 * This file is the canonical source. It is deliberately `.js` so that it can be
 * imported by Gatsby Node API files (Parcel bundle) which cannot resolve `.ts`
 * files from workspace packages. The edge function at
 * sites/invisiblefence/edge_functions/user-location.js keeps a manual copy.
 */
export const sanitizeForUrl = (str = '') =>
  str
    .toLowerCase()
    .replaceAll(/[\u00ae\u2122\u00a9]/g, '')
    .replaceAll(/[^a-z0-9-]/g, '-')
    .replaceAll(/-+/g, '-')
    .replaceAll(/(^-)|(-$)/g, '');
